import React from 'react';
import { T, useTheme, Ico } from '../../../design';
import type { IconName } from '../../../design';

export type CourseTab = 'list' | 'mine' | 'salon' | 'approve';

interface TabDef { k: CourseTab; label: string; icon: IconName; badge?: number }

export interface TabBarProps {
  tab: CourseTab;
  onTab: (tab: CourseTab) => void;
  role: 'owner' | 'member';
  pendingCount: number;
}

export function TabBar({ tab, onTab, role, pendingCount }: TabBarProps) {
  const t = useTheme();
  const tabs: TabDef[] = [
    { k: 'list', label: 'Kurser', icon: 'book' },
    { k: 'mine', label: 'Mine', icon: 'user' },
  ];
  if (role === 'owner') {
    tabs.push({ k: 'salon', label: 'Salon', icon: 'store' });
    tabs.push({ k: 'approve', label: 'Godkend', icon: 'checkCircle', badge: pendingCount });
  }

  const onKey = (e: React.KeyboardEvent, idx: number) => {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    e.preventDefault();
    const next = e.key === 'ArrowRight' ? (idx + 1) % tabs.length : (idx - 1 + tabs.length) % tabs.length;
    onTab(tabs[next].k);
  };

  return (
    <nav role="tablist" aria-label="Kursus-faner" style={{ background: T.surface, borderBottom: `1px solid ${T.border}`, display: 'flex', gap: 4, padding: '8px 10px', overflowX: 'auto' }}>
      {tabs.map((tb, idx) => {
        const on = tab === tb.k;
        const Ic = Ico[tb.icon];
        return (
          <button
            key={tb.k}
            role="tab"
            aria-selected={on}
            tabIndex={on ? 0 : -1}
            onKeyDown={(e) => onKey(e, idx)}
            onClick={() => onTab(tb.k)}
            style={{ flex: '1 0 auto', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, padding: '9px 14px', border: 0, borderRadius: 999, whiteSpace: 'nowrap', cursor: 'pointer', background: on ? t.accent : T.surface, color: on ? T.onAccent : T.fg2, fontFamily: T.font, fontSize: 13, fontWeight: 700, position: 'relative', transition: 'all 140ms' }}
          >
            <Ic size={16} />{tb.label}
            {tb.badge != null && tb.badge > 0 && <span style={{ minWidth: 18, height: 18, padding: '0 5px', borderRadius: 999, background: on ? T.accentLight : T.error, color: on ? T.accent : T.onAccent, fontSize: 10.5, fontWeight: 800, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{tb.badge}</span>}
          </button>
        );
      })}
    </nav>
  );
}
